import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=d80098e8&scoped=true&"
import script from "./BannerSlider.vue?vue&type=script&lang=js&"
export * from "./BannerSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80098e8",
  null
  
)

export default component.exports